import axios from "axios";
import { API_URL, getAuthHeader } from ".";
import { ResponseModel } from "../Models/ResponseModel";
import { Job } from "../Models/Job";
import { JobItem } from "../Models/JobItem";
import { SchedulerObj } from "../Models/SchedulerObj";
import { SchedulerItemDto } from "../Models/SchedulerItemDto";

class JobApi {
  static getJob(id: string) {
    return axios.get<Job>(`${API_URL}/api/job/${id}`, getAuthHeader());
  }
  static getJobList() {
    return axios.get<Job[]>(`${API_URL}/api/job`, getAuthHeader());
  }
  static addUpdateJob(request: Job) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/job`,
      request,
      getAuthHeader()
    );
  }
  static updateStartDate(jobId: number, newStartDate: string) {
    return axios.put<ResponseModel>(
      `${API_URL}/api/job/${jobId}/startDate/${newStartDate}/update`,
      null,
      getAuthHeader()
    );
  }
  static deleteJob(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/job/${id}`,
      getAuthHeader()
    );
  }
  static softDeleteJob(id: number) {
    return axios.put<ResponseModel>(
      `${API_URL}/api/job/${id}/softdelete`,
      null,
      getAuthHeader()
    );
  }
  static getJobItem(id: string) {
    return axios.get<JobItem>(
      `${API_URL}/api/job/jobitem/${id}`,
      getAuthHeader()
    );
  }
  static getJobItemsList() {
    return axios.get<JobItem[]>(`${API_URL}/api/job/jobitem`, getAuthHeader());
  }
  static getJobJobItemsList(id: number) {
    return axios.get<JobItem[]>(
      `${API_URL}/api/job/jobitem/list/${id}`,
      getAuthHeader()
    );
  }
  static addUpdateJobItem(request: JobItem) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/job/jobitem`,
      request,
      getAuthHeader()
    );
  }
  static deleteJobItem(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/job/jobitem/${id}`,
      getAuthHeader()
    );
  }
  static getSchedulerData(startDate: string, endDate: string) {
    return axios.get<SchedulerItemDto[]>(
      `${API_URL}/api/job/schedule/${startDate}/${endDate}`,
      getAuthHeader()
    );
  }
  static sendNotification(jobId: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/job/${jobId}/notification/send`,
      null,
      getAuthHeader()
    );
  }
}

export default JobApi;
